<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        11.30
        <br />2017
      </span>
      <span class="tiel">与互联网大咖齐聚乌镇，美菜将共享精准扶贫红利</span>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_01.jpg" width="640" />
      </p>
      <div class="tet-js">
        千年水乡，智慧乌镇。第四届世界互联网大会•乌镇峰会将于12月3日在乌镇举办，大会的主题是“发展数字经济 促进开放共享——携手共建网络空间命运共同体”。
        <br />
        <br />届时，来自全世界的互联网大咖将齐聚乌镇。
      </div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_02.jpg" width="640" />
      </p>
      <div
        class="tet-js"
      >阿里巴巴集团董事局主席马云，百度创始人、董事长兼CEO李彦宏，腾讯董事会主席兼CEO马化腾等互联网大佬，微软、脸谱、领英等外国企业主要负责人也会到场。</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_03.jpg" width="640" />
      </p>
      <div class="tet-js">
        同时，这也是美菜第三次站在世界的舞台，美菜虽刚刚发展到第四个年头，却连续三届受邀。再次证明，它的声音早已被世界记住......
        <br />
        <br />目前，美菜网的展台正在紧锣密鼓的搭建展台中，准备迎接八方来客。
      </div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_04.jpg" width="640" />
      </p>
      <div class="tet-js">
        今年，美菜网创始人、CEO刘传军将参加共享红利:互联网精准扶贫分论坛。据悉，论坛邀请来自国际组织、政府、企业家、专家代表，分享互联网精准脱贫的政策措施和典型案例，探讨如何更好发挥政府、企业、社会组织、受助者及公众的作用，坚决打赢脱贫攻坚战。
        <br />
        <br />届时，创始人刘传军将在现场对话中国三星高级副总裁李秉澈、金山云首席执行官李政等人，共同探讨企业的社会责任，发挥互联网在脱贫攻坚中的作用，扎实推进精准扶贫、精准脱贫。
      </div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_05.jpg" width="640" />
      </p>
      <div
        class="tet-js"
      >作为精准扶贫的践行者，美菜在精准扶贫方面采取了很多行动。不但实施了扶贫菜助销计划，在网站开辟扶贫菜专区，采销贫困地区农产品，还计划进一步下沉供应链，大力拓展农产品源头布局，在农村建设农产品基地，并重点向贫困地区倾斜，让贫困地区的资源真正流动起来，实现真脱贫。</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_06.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">（美菜网创始人、CEO刘传军参加第二届世界互联网大会）</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_07.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">（美菜网创始人、CEO刘传军参加第三届世界互联网大会）</div>
      <div
        class="tet-js"
      >扶贫更需扶智，输血更要造血。在美菜公司成立两周年之际，其依托中国红十字基金会设立了“最美菜公益基金”，两年多来，美菜网已经开展了小候鸟关爱计划、最美教室、最美包裹、最美扶贫公开课等项目，为农村留守儿童送去温暖，为贫困农村摆脱困境带去了光明。</div>
    </div>
    <div class="mat-content">
      <p align="center">
        <img src="@/assets/images/new-img/a8_08.jpg" width="640" />
      </p>
      <div class="tet-js">第四届世界互联网大会，美菜来了！敬请关注美菜网在世界互联网大会的精彩表现！</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item"
};
</script>

<style lang="scss" scoped>
</style>
